import React, { useState, useEffect, useContext } from "react"
import { Button, message, Dropdown, Flex } from "antd"
import { UserContext, useUser } from "../../contexts/UserContext"
import UserFields from "../../components/UserFields/User"
import Organization from "../../components/UserFields/Organization"
import ResellerFields from "../../components/UserFields/Reseller"
import AdminFields from "../../components/UserFields/Admin"
import { useTranslation } from "react-i18next"

const RegisterUser = () => {
    const { user } = useContext(UserContext)
    const { getToken, isAdmin, getRole } = useUser()
    const [accountType, setAccountType] = useState(-1)
    const [messageApi, contextHolder] = message.useMessage()
    const { t } = useTranslation()

    useEffect(() => {
    }, [])

    function getOptions() {
        var items = []

        for (var i = 0; i < user.roleId; ++i) {
            items.push({ label: t(getRole(i)), key: i });
        }
        if(user.roleId == 3)  
            items.push({ label: t('page.newaccount.org'), key: 4 })
        return items;
    }

    function getRoleName(role) {
        if (role == -1)
            return t('page.newaccount.acctype')
        if (role == 4)
            return t('page.newaccount.org')

        return getRole(accountType);
    }

    function getRoleForm(Role) {
        switch (Role) {
            case 0:
                return (<UserFields messageApi={messageApi}></UserFields>)
            case 1:
                return (<ResellerFields messageApi={messageApi}></ResellerFields>)
            case 2:
                return (<AdminFields messageApi={messageApi}></AdminFields>)
            case 4:
                return (<Organization messageApi={messageApi}></Organization>)
        }
    }
    
    return (
        <>
            
            <Flex style={{ flexWrap: "wrap", flexDirection: "column", alignContent: "space-around", alignItems: "center" }}>
                {contextHolder}
                <header style={{ display: "flex", justifyContent: "center" }} ><h1>{t('page.newaccount.header')}</h1></header>
                <Dropdown menu={{ items: getOptions(), onClick: (e) => { setAccountType(parseInt(e.key)) } }}><Button style={{ width: "300px", marginBottom: "50px" }}>{t(getRoleName(accountType))}</Button></Dropdown>
                
                {getRoleForm(accountType)}

                
            </Flex>
        </>
    )
}

export default RegisterUser
